module.exports = __webpack_public_path__ + "static/media/LCB_GraffitiPinEndCard.1f9ec74e.png";